import { render, staticRenderFns } from "./testimonialSlider.vue?vue&type=template&id=7a425a8e&"
import script from "./testimonialSlider.vue?vue&type=script&lang=js&"
export * from "./testimonialSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports